// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"638":"cea39833","775":"10d979ca"}[chunkId] + ".js";
};